import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskList';

const taskListService = {
  getTasklistById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getTasklistsByLineId: (lineId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/taskLists/${encodeURIComponent(lineId)}`,
    });
  },

  getTaskListTemplates: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/templates`,
      data,
    });
  },

  createTaskListTemplate: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  createTaskList: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/newTasklist`,
      formData: true,
      data,
    });
  },

  updateTaskList: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/taskList/gridTask`,
      formData: true,
      data,
    });
  },

  uploadFile: (file, id, userId) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('userId', userId);

    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteFile: (id, userId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
      data: { userId },
    });
  },

  getTaskList: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/taskList`,
      data,
    });
  },

  getGridTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/gridTasks`,
      data,
    });
  },

  updateStatus: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/status`,
      data,
    });
  },

  updateTaskListTemplate: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteTaskListTemplate: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  updateTaskListName: (data, id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  createTaskListReport: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/taskList/taskListReport`,
      formData: true,
      data,
    });
  },

  deleteTaskList: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/tasklist/${encodeURIComponent(id)}`,
      data,
    });
  },

  getTasklistReports: (taskListId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/taskListReports/${encodeURIComponent(taskListId)}`,
    });
  },

  deleteTaskListReport: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/taskListReport/${encodeURIComponent(id)}`,
      data,
    });
  },
};

export default taskListService;
